module.exports = __webpack_public_path__ + "img/download-icon.044d8451.svg";